import 'css-chunksrc/client/pages/zonePage/wbsPage/exportButton/styles.scss';export default {
  "exportButton": "_exportButton_1iefk_1",
  "text": "_text_1iefk_17",
  "icon": "_icon_1iefk_21"
};